module.exports = __webpack_public_path__ + "img/google-ad.4e84c6b8.png";